import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/earth.png';
import _imports_1 from '@/assets/home_arrow.png';
import _imports_2 from '@/assets/home_sanku.png';
import _imports_3 from '@/assets/hand-heart.png';
const _withScopeId = n => (_pushScopeId("data-v-9a6201a6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "fs-s"
};
const _hoisted_2 = {
  class: "block block1"
};
const _hoisted_3 = {
  class: "text-box d-flex jc-between ai-center main-width"
};
const _hoisted_4 = {
  class: ""
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "logotitle fs-l fw-b light_blue"
}, "WELL碳手印", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title pt-20 pb-20 fs-xl fw-b text-purple"
}, "最佳实践项目评级", -1));
const _hoisted_7 = ["innerHTML"];
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}, null, -1));
const _hoisted_9 = {
  class: "block block2 bg-bggray"
};
const _hoisted_10 = {
  class: "main-width content_box"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title fs-l fw-b"
}, "碳手印项目增长趋势", -1));
const _hoisted_12 = {
  class: "chart_box d-flex pt-40 pb-80"
};
const _hoisted_13 = {
  class: "item_content fw-b blue fs-m pb-2"
};
const _hoisted_14 = {
  class: "item_title text-gray fs-xs"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "chart1"
}, null, -1));
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<div class=\"arrow_img d-flex jc-center bg-bggray\" data-v-9a6201a6><img src=\"" + _imports_1 + "\" width=\"100\" data-v-9a6201a6><img src=\"" + _imports_1 + "\" width=\"100\" data-v-9a6201a6><img src=\"" + _imports_1 + "\" width=\"100\" data-v-9a6201a6><img src=\"" + _imports_1 + "\" width=\"100\" data-v-9a6201a6><img src=\"" + _imports_1 + "\" width=\"100\" data-v-9a6201a6></div>", 1);
const _hoisted_17 = {
  class: "block block_c bg-bggray"
};
const _hoisted_18 = {
  class: "main-width d-flex jc-between ai-center content_box"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "fs-m title"
}, "碳手印项目库/产品库/服务库", -1));
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "pt-10 pb-40 fs-xl fw-b subtitle"
}, "三库联动·生态协同", -1));
const _hoisted_21 = {
  class: "d-flex ai-center pb-10"
};
const _hoisted_22 = {
  class: "pl-5 fs-m fw-b item_content"
};
const _hoisted_23 = {
  class: "pl-5 fs-x item_des"
};
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  width: "350"
}, null, -1));
const _hoisted_25 = {
  class: "block block5"
};
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "main-width title_box text-white"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "title fs-l fw-b"
}, "碳手印最佳实践项目奖"), /*#__PURE__*/_createElementVNode("div", {
  class: "subtitle fs-m pt-10 pb-40"
}, "每一个奖项背后都是沉甸甸的信任与期待")], -1));
const _hoisted_27 = {
  class: "award_list d-flex jc-between main-width"
};
const _hoisted_28 = {
  class: "img_box"
};
const _hoisted_29 = ["src"];
const _hoisted_30 = {
  class: "title_box"
};
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "img_box_subtitle"
}, "碳手印最佳实践项目", -1));
const _hoisted_32 = {
  class: "img_box_title"
};
const _hoisted_33 = {
  class: "item-bottom text-center"
};
const _hoisted_34 = {
  class: "fw-b pt-20 text-white"
};
const _hoisted_35 = ["innerHTML"];
const _hoisted_36 = {
  class: "block block3"
};
const _hoisted_37 = {
  class: "main-width content_box"
};
const _hoisted_38 = {
  class: "d-flex jc-between ai-center pt-20 content_subbox"
};
const _hoisted_39 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title fs-l fw-b pb-40 blue"
}, "倡议与实践", -1));
const _hoisted_40 = {
  class: "text-box pb-40"
};
const _hoisted_41 = {
  class: "pb-20"
};
const _hoisted_42 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3
}, null, -1));
import echarts from '@/utils/echarts.js';
import { onMounted } from 'vue';
import { WOW } from 'wowjs';
import { Select } from '@element-plus/icons-vue';
import wx from 'weixin-js-sdk';
import axios from 'axios';
import { useStore } from 'vuex';
export default {
  __name: 'ProjectActive',
  setup(__props) {
    const store = useStore();
    const textData = {
      block1: '本活动以发掘优秀碳手印案例、展示碳手印成果、<br>提升碳手印能力为目标。通过激发企业和园区的<br>自主减碳意愿，每年评选并发布一批碳手印最佳<br>实践项目。',
      block2: '*越来越多的伙伴加入我们，展示<br>他们优秀的控碳案例。',
      // block3_1: '● 本活动以发掘优秀控碳案例、展示创新控碳成果、提升自主控碳能力为目标。',
      block3_2: '● 本活动将每年评选并发布相关行业技术创新类、企业应用类、园区应用类 10 强榜单，推出　　一批银级、金级、铂金级最佳实践项目。',
      block3_3: '● 本活动注重审查作品的数据精细性和计量精准性，致力于打造业界最为严苛、最值得信赖、最具实用性的评级活动。'
    };
    const block2Data = [{
      title: '受影响人数',
      content: '68,000+'
    }, {
      title: '建筑面积（m²）',
      content: '1,291,000+'
    }, {
      title: '区域（县级）',
      content: '12+'
    }, {
      title: '平均增长速度',
      content: '54%'
    }];
    const balanceList = [{
      content: '项目库',
      color: '#9cbc11',
      des: '高度认同碳手印理念的绿色企业及园区'
    }, {
      content: '产品库',
      color: '#0d6269',
      des: '符合碳手印标准并实施分级管理的绿色产品'
    }, {
      content: '服务库',
      color: '#0896d4',
      des: '符合碳手印标准并实施分级管理的绿色服务'
    }
    // { content: '与碳友们共同进步', color: '#f98514' }
    ];

    const reportList = [{
      title: '案例一',
      content: '案例一介绍案例一介绍案例一介绍案例一介绍案例一介绍案例一介绍案例一介绍'
    }, {
      title: '案例二',
      content: '案例二介绍案例二介绍案例二介绍案例二介绍案例二介绍案例二介绍案例二介绍'
    }];
    const awardsList = [{
      title: '银奖',
      content: '符合标准所要求的100%<br>先决条件的项目',
      url: require('@/assets/logo/blue_logo_bg.png')
    }, {
      title: '金奖',
      content: '符合100%先决条件及40%以上<br>优化创新条件的项目',
      url: require('@/assets/logo/sliver_logo_bg.png')
    }, {
      title: '铂金奖',
      content: '符合100%先决条件及80%以上<br>优化创新条件的项目',
      url: require('@/assets/logo/gold_logo_bg.png')
    }];
    const wxFunc = function () {
      const params = store.state.VUEX_SHARECONFIG.projectActive;
      wx.ready(function () {
        //需在用户可能点击分享按钮前就先调用
        wx.updateAppMessageShareData({
          ...params,
          success: function () {
            // 设置成功
          }
        });
      });
    };
    const toApplyPage = () => {
      location.href = "https://f.wps.cn/g/QhQ5zNRx/";
    };
    const initChart = function () {
      const myChart = echarts.init(document.getElementById('chart1'));
      const option = {
        color: ['#3a7296'],
        tooltip: {},
        grid: {
          top: '0%',
          bottom: '0%',
          left: '0%',
          right: '0%',
          containLabel: true
        },
        xAxis: {
          data: ["2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022"]
        },
        yAxis: {
          show: false
        },
        series: [{
          data: [0, 2, 5, 5, 7, 10, 12, 20, 50],
          type: "bar",
          stack: "x"
        }]
      };
      myChart.setOption(option);
      window.addEventListener("resize", function () {
        myEChart.resize();
      });
    };
    onMounted(() => {
      initChart();
      new WOW({
        live: false,
        offset: 0
      }).init();
      wxFunc();
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_icon = _resolveComponent("el-icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _hoisted_6, _createElementVNode("div", {
        class: "slogantext pb-10",
        innerHTML: textData.block1
      }, null, 8, _hoisted_7), _createVNode(_component_el_button, {
        class: "btn",
        color: "#327db9",
        dark: "",
        onClick: toApplyPage
      }, {
        default: _withCtx(() => [_createTextVNode("提交您的碳手印项目作品")]),
        _: 1
      })]), _hoisted_8])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_hoisted_11, _createElementVNode("div", _hoisted_12, [_createElementVNode("div", null, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(block2Data, (item, idx) => {
        return _createElementVNode("div", {
          class: "pb-20",
          key: idx
        }, [_createElementVNode("div", _hoisted_13, _toDisplayString(item.content), 1), _createElementVNode("div", _hoisted_14, _toDisplayString(item.title), 1)]);
      }), 64))]), _hoisted_15])])]), _hoisted_16, _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createElementVNode("div", null, [_hoisted_19, _hoisted_20, _createElementVNode("div", null, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(balanceList, (item, idx) => {
        return _createElementVNode("div", {
          class: "pb-10",
          key: idx
        }, [_createElementVNode("div", _hoisted_21, [_createVNode(_component_el_icon, {
          color: item.color,
          size: "20"
        }, {
          default: _withCtx(() => [_createVNode(_unref(Select))]),
          _: 2
        }, 1032, ["color"]), _createElementVNode("div", _hoisted_22, _toDisplayString(item.content), 1)]), _createElementVNode("div", _hoisted_23, _toDisplayString(item.des), 1)]);
      }), 64))])]), _hoisted_24])]), _createElementVNode("div", _hoisted_25, [_hoisted_26, _createElementVNode("div", _hoisted_27, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(awardsList, (item, idx) => {
        return _createElementVNode("div", {
          class: "list-item",
          key: idx
        }, [_createElementVNode("div", _hoisted_28, [_createElementVNode("img", {
          src: item.url
        }, null, 8, _hoisted_29), _createElementVNode("div", _hoisted_30, [_hoisted_31, _createElementVNode("div", _hoisted_32, _toDisplayString(item.title), 1)])]), _createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, _toDisplayString(item.title), 1), _createElementVNode("div", {
          class: "fs-xs pt-10 text-white",
          innerHTML: item.content
        }, null, 8, _hoisted_35)])]);
      }), 64))])]), _createElementVNode("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, [_createElementVNode("div", null, [_hoisted_39, _createElementVNode("div", _hoisted_40, [_createElementVNode("div", _hoisted_41, _toDisplayString(textData.block3_2), 1), _createElementVNode("div", null, _toDisplayString(textData.block3_3), 1)]), _createVNode(_component_el_button, {
        class: "btn",
        color: "#327db9",
        dark: "",
        onClick: toApplyPage
      }, {
        default: _withCtx(() => [_createTextVNode("提交您的碳手印项目作品")]),
        _: 1
      })]), _hoisted_42])])])]);
    };
  }
};